module.exports = __webpack_public_path__ + "static/media/avatar.5110c536.png";